import { render, staticRenderFns } from "./fenrunGuize.vue?vue&type=template&id=41b473e6&scoped=true"
import script from "./fenrunGuize.vue?vue&type=script&lang=js"
export * from "./fenrunGuize.vue?vue&type=script&lang=js"
import style0 from "./fenrunGuize.vue?vue&type=style&index=0&id=41b473e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b473e6",
  null
  
)

export default component.exports